export default {
  Controls: {
    Loading: 'Đang tải...',
    Select: {
      Placeholder: 'Chọn',
      Loading: 'Đang tải',
      NoMatch: 'Không có kết quả phù hợp',
      NoData: 'Không có dữ liệu để hiển thị'
    },
    Table: {
      EmptyText: 'Chưa có dữ liệu',
      NoResult: 'Không tìm thấy dữ liệu',
      SumText: 'Tổng'
    },
    MessageBox: {
      Cancel: 'Hủy',
      Ignore: 'Bỏ qua',
      Confirm: 'Đồng ý'
    },
    UploadField: {
      PickAFile: 'Hãy chọn 1 file',
      ExtensionNotAllow: 'Định dạng file không hợp lệ',
      ExtensionNotAllowExcel: 'File không hợp lệ',
      SizeLimit: 'Dung lượng file không được vượt quá',
      UploadFail: 'Gặp lỗi trong quá trình tải file!',
      NumberFileLimit: 'Vượt quá số lượng file được phép',
      FileDurationTooLong: 'Video vượt quá 1 phút. Vui lòng rút ngắn thời lượng'
    },
    Tree: {
      EmptyText: 'Không có dữ liệu để hiển thị'
    },
    Pagination: {
      GoTo: 'Đi đến',
      PageClassifier: 'Trang',
      Record: 'bản ghi',
      Total: 'Tổng {total} {recordName}'
    },
    DatePicker: {
      Now: 'Hôm nay',
      Confirm: 'OK',
      Cancel: 'Huỷ',
      Year: 'Năm',
      Month: 'Tháng',
      Week: 'Tuần',
      SelectDate: 'Chọn ngày',
      SelectTime: 'Chọn giờ',
      StartDate: 'Ngày bắt đầu',
      StartTime: 'Thời gian bắt đầu',
      EndDate: 'Ngày kết thúc',
      EndTime: 'Thời gian kết thúc',
      PrevYear: 'Năm trước',
      NextYear: 'Năm tới',
      PrevMonth: 'Tháng trước',
      NextMonth: 'Tháng sau',
      Today: 'Hôm nay',
      Weeks: {
        sun: 'CN',
        mon: 'T2',
        tue: 'T3',
        wed: 'T4',
        thu: 'T5',
        fri: 'T6',
        sat: 'T7'
      },
      Months: {
        jan: 'Th.1',
        feb: 'Th.2',
        mar: 'Th.3',
        apr: 'Th.4',
        may: 'Th.5',
        jun: 'Th.6',
        jul: 'Th.7',
        aug: 'Th.8',
        sep: 'Th.9',
        oct: 'Th.10',
        nov: 'Th.11',
        dec: 'Th.12'
      }
    }
  }
}
